import React from 'react';
import Link from 'next/link';
import type { GoldPrices, GoldRow } from './prices';

/** Định dạng nghìn đồng/chỉ: 14180 → "14,180" (như app) */
export const fmtChi = (n: number | null) => (n ? n.toLocaleString('en-US') : '—');

export const Delta = ({ value }: { value: number }) =>
  value ? (
    <span className={`tw-block tw-text-[11px] tw-leading-tight tw-mt-0.5 ${value > 0 ? 'tw-text-[#219B64]' : 'tw-text-[#C0392B]'}`}>
      {value > 0 ? '▲ +' : '▼ −'}
      {Math.abs(value).toLocaleString('en-US')}
    </span>
  ) : null;

const CARD_KEYS = ['BTMC VRTL', 'PNJ TP.HCM', 'SJC'];

export const pickCardRows = (gold: GoldPrices): GoldRow[] => {
  const rows = CARD_KEYS.map((k) => gold.rows.find((r) => r.name === k)).filter(Boolean) as GoldRow[];
  return rows.length ? rows : gold.rows.slice(0, 3);
};

/**
 * Thẻ giá vàng dùng chung (thiết kế an-thu-ui-update).
 * variant "card": trang chủ (có tiêu đề + nút xem đầy đủ). variant "band": khối trong /tin-tuc/ (chỉ bảng, cột căn giữa).
 */
export const GoldCard = ({ gold, className = '', variant = 'card' }: { gold: GoldPrices | null; className?: string; variant?: 'card' | 'band' }) => {
  const band = variant === 'band';
  const cols = band ? 'tw-grid-cols-[1fr_84px_84px] sm:tw-grid-cols-[1fr_130px_130px] tw-text-center' : 'tw-grid-cols-[1fr_64px_64px]';
  const num = band ? 'tw-text-center' : 'tw-text-right';
  return (
    <div className={`tw-bg-white tw-border tw-border-solid tw-border-[#DECA95] tw-text-[#30220E] ${className}`}>
      <div className="tw-p-4 tw-pb-3">
        {!band && <h3 className="tw-m-0 tw-border-0 tw-border-l-[3px] tw-border-solid tw-border-[#AF9454] tw-pl-3 tw-text-[15px] tw-font-bold tw-uppercase tw-leading-tight">Giá vàng hôm nay</h3>}
        <p className={`tw-m-0 ${band ? '' : 'tw-mt-2 tw-text-[#AF9454]'} tw-text-[13px]`}>Nghìn đồng/chỉ</p>
      </div>
      {gold ? (
        <>
          <div className={`tw-grid ${cols} tw-gap-x-2 tw-bg-[#FEF8E0] tw-px-4 tw-py-3 tw-text-[13px] ${band ? 'tw-text-[#AF9454] tw-text-[14px]' : 'tw-text-[#AF9454] tw-text-[11px]'}`}>
            <span className="tw-text-left">Sản phẩm</span>
            <span className={band ? '' : 'tw-text-right'}>Mua vào</span>
            <span className={band ? '' : 'tw-text-right'}>Bán ra</span>
          </div>
          {pickCardRows(gold).map((r) => (
            <div key={r.key} className={`tw-grid ${cols} tw-gap-x-2 tw-items-start tw-px-4 tw-py-3 tw-text-[13px] ${band ? 'tw-border-0 tw-border-b tw-border-solid tw-border-[#DECA95]/40 tw-text-[15px]' : ''}`}>
              <span className="tw-pt-0.5 tw-text-left">{r.name}</span>
              <span className={`${num} ${band ? '' : 'tw-font-bold'}`}>
                <span className={band ? 'tw-font-medium' : ''}>{fmtChi(r.buy)}</span>
                <Delta value={r.buyDelta} />
              </span>
              <span className={`${num} ${band ? '' : 'tw-font-bold'}`}>
                <span className={band ? 'tw-font-medium' : ''}>{fmtChi(r.sell)}</span>
                <Delta value={r.sellDelta} />
              </span>
            </div>
          ))}
          <p className="tw-m-0 tw-bg-[#FEF8E0] tw-px-4 tw-py-3 tw-text-[12px] tw-text-[#AF9454]">
            {gold.source} · {gold.updatedAt}
          </p>
        </>
      ) : (
        <p className="tw-m-0 tw-bg-[#FEF8E0] tw-px-4 tw-py-6 tw-text-[13px] tw-text-[#AF9454]">Chưa có dữ liệu giá vàng. Vui lòng quay lại sau ít phút.</p>
      )}
      {!band && (
        <div className="tw-p-4">
          <Link href="/bang-gia/gia-vang/">
            <a className="tw-flex tw-min-h-[40px] tw-items-center tw-justify-center tw-bg-[#0F6656] tw-text-[13px] tw-font-medium !tw-text-white hover:!tw-text-white">Xem đầy đủ giá vàng →</a>
          </Link>
        </div>
      )}
    </div>
  );
};
